import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { MasterService } from '../../../base-classes/master-service';
import { Package, Client } from '../../test-suite/models';

@Injectable({ providedIn: 'root' })
export class PackagesService extends MasterService<Package> {
  constructor(http: HttpClient) {
    super(http, `${environment.apiUrl}/packages`);
    this.http = http;
  }

  getAllClients(): Observable<Client[]> {
    return this.http.get<Client[]>(`${environment.apiUrl}/clients`);
  }

  getAllPackages(): Observable<Package[]> {
    return this.http.get<Package[]>(`${environment.apiUrl}/packages`);
  }

  createPackage(payload: Partial<Package> & { packageName: string; packageDescription?: string }): Observable<Package> {
    return this.http.post<Package>(`${environment.apiUrl}/packages`, payload);
  }

  updatePackage(id: string, payload: Partial<Package>): Observable<Package> {
    return this.http.put<Package>(`${environment.apiUrl}/packages/${id}`, payload);
  }

  deletePackage(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/packages/${id}`);
  }
}
